'use client';

import { useEffect } from 'react';

/**
 * Replaces the root layout when an error bubbles past `app/error.tsx`.
 * Must define `<html>` and `<body>` (Next.js App Router requirement).
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <body style={{ margin: 0, minHeight: '100dvh', background: '#000', color: '#fafafa' }}>
        <div
          style={{
            display: 'flex',
            minHeight: '100dvh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
            padding: '1rem',
            fontFamily: 'system-ui, sans-serif',
          }}
          role="alert"
        >
          <h1 style={{ fontSize: '1.125rem', fontWeight: 600 }}>Something went wrong</h1>
          <p style={{ maxWidth: '24rem', textAlign: 'center', fontSize: '0.875rem', opacity: 0.8 }}>
            A critical error occurred. Try again or reload the page.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              borderRadius: '0.375rem',
              background: '#fff',
              color: '#000',
              padding: '0.5rem 1rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
